import PortfolioItem from "./PortfolioItem";
import Projects from "./ProjectsData";

export default function Portfolio() {
  return (
    <div className="PortfolioContainer min-h-screen flex flex-col items-center space-y-24 px-5">
      <h1 className="font-bold text-[clamp(30px,5vw,100px)] mt-10">PORTFOLIO</h1>
      <div className="flex flex-col w-full lg:flex-row justify-center items-center ">
        {Object.values(Projects).map((projectItem, index) => (
          <PortfolioItem
            key={index}
            ProjectImags={projectItem.image}
            ProjectTitle={projectItem.title}
            ProjectTechnology={projectItem.technology}
            ProjectWebsiteLink={projectItem.websiteLink}
          />
        ))}
      </div>
    </div>
  );
}
